const ACCOUNTS = {
    apple: require('../assets/account/apple.txt').default,
};

export default ACCOUNTS;
